<template>
  <router-view />
  <NatsInspectorOverlay />
  <BuildVersionTag />
</template>

<script setup lang="ts">
import { NatsInspectorOverlay } from '@omniflow/nats-inspector'
import BuildVersionTag from 'src/shared/ui/BuildVersionTag.vue'
</script>
